import { useMutation } from "@tanstack/react-query";
import { useNotification } from "@refinedev/core";

import { ApiError } from "@shared/types";
import { getErpErrorMessage } from "@modules/erpIntegrations/utils";

import { deleteConfigService } from "./service";
import { UseDeleteConfigMutationOptions } from "./types";

export function useDeleteConfigMutation(options?: UseDeleteConfigMutationOptions) {
  const { open } = useNotification();

  return useMutation<void, ApiError, number>({
    mutationFn: deleteConfigService,
    onError: (error) => {
      open?.({
        type: "error",
        message: getErpErrorMessage(error),
      });
    },
    ...options,
  });
}
